import { render, staticRenderFns } from "./WinerySocialMedia_Mobile.vue?vue&type=template&id=f2bb3864&"
import script from "./WinerySocialMedia_Mobile.vue?vue&type=script&lang=js&"
export * from "./WinerySocialMedia_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports